import { H1 } from '@atlassian/amkt-common';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import * as perspectives from '../../../../../../constants/perspectives';

import styles from './LargeHeroContainer.less';
import AppsMirror from './images/AppsMirror.svg';

export default class LargeHeroContainer extends Component {
  static propTypes = {
    discoverHeading: PropTypes.string.isRequired,
    perspective: perspectives.propType.isRequired,
  };

  render() {
    return (
      <div className={styles.largeHeroContainer}>
        <TransitionGroup className={styles.contentTransition}>
          {this.props.perspective === perspectives.DISCOVER ? (
            <CSSTransition
              classNames={{
                enter: styles.rollDown,
                enterActive: styles.rollDownActive,
                exit: styles.rollUp,
                exitActive: styles.rollUpActive,
              }}
              enter={true}
              exit={true}
              timeout={400}
            >
              <div className={styles.largeHeroInner}>
                <div className={styles.splitHero}>
                  <div className={styles.heroLeft}>
                    <H1>{this.props.discoverHeading}</H1>
                  </div>
                  <div className={styles.heroRight}>
                    <img className={styles.largeHeroImage} src={AppsMirror} alt="" />
                  </div>
                </div>
              </div>
            </CSSTransition>
          ) : null}
        </TransitionGroup>
      </div>
    );
  }
}
